import { authActions } from "../slices/authSlice";
import axios from "axios";
import { toast } from "react-toastify";
import { attendanceActions } from "../slices/attendanceSlice";


// Login User 
// export function loginUser(user){
//     return async(dispatch ) => {
//        try {

//         const {data} = await axios.post("https://remote-attendance.hsagroup.info/api/auth/login" , user)

//         dispatch(authActions.login(data));
//         localStorage.setItem("userInfo" , JSON.stringify(data));
//         console.log(data);

//        } catch (error) {

//         toast.error(error.response.data.message);
//         console.log(error);
//        } 
//     }
// }

export function loginUser(user){
    return async(dispatch ) => {
       try {

        const {data} = await axios.post(
          "https://remote-attendance.hsagroup.info/api/auth/login",
          user
        );

        // 🚨 IF 2FA REQUIRED
        if(data.twoFactorRequired){
            localStorage.setItem("twoFactorUserId", data.userId);
            window.location.href = "/verify-2fa";
            return;
        }

        // NORMAL LOGIN
        dispatch(authActions.login(data));
        localStorage.setItem("userInfo", JSON.stringify(data));

       } catch (error) {

        toast.error(error.response.data.message);
        console.log(error);
       } 
    }
}

// Logout User 
export function logoutUser(){
    return (dispatch ) => {

        dispatch(attendanceActions.clearAttendance());

        dispatch(authActions.logout());
        localStorage.removeItem("userInfo");
        dispatch(attendanceActions.clearAttendanceReport());
        
    
    }
}


// Register User 
export function RegisterUserApi(user){
    return async(dispatch , getState ) => {
       try {

        const {data} = await axios.post("https://remote-attendance.hsagroup.info/api/auth/register" , user , {
            headers:{
                Authorization: "Bearer " + getState().auth.user.token,
            }
        })

        dispatch(authActions.register(data.message));
        console.log(data);

       } catch (error) {

        toast.error(error.response.data.message);
        console.log(error);
       } 
    }
}



// Verify Email 
export function verifyEmailApi(userId,token){
    return async(dispatch , getState ) => {
       try {

        await axios.get(`https://remote-attendance.hsagroup.info/api/auth/${userId}/verify/${token}`) ;
        dispatch(authActions.setIsEmailVerified());
        

       } catch (error) {

        toast.error(error.response.data.message);
        console.log(error);
       } 
    }
}


// VERIFY 2FA LOGIN
export function verify2FAApi(token){
    return async(dispatch)=>{
        try{

            const userId = localStorage.getItem("twoFactorUserId");

            const {data} = await axios.post(
                "https://remote-attendance.hsagroup.info/api/auth/login/2fa",
                {userId , token}
            );

            dispatch(authActions.login(data));

            localStorage.setItem("userInfo", JSON.stringify(data));
            localStorage.removeItem("twoFactorUserId");

            window.location.href = "attendance";

        }catch(error){
            toast.error(error.response.data.message);
        }
    }
}


// 1️⃣ Enable 2FA - generate QR & temp secret
export function enable2FAApi(){
    return async(dispatch, getState)=>{
        try{
            const {user} = getState().auth;
            const {data} = await axios.post(
                "https://remote-attendance.hsagroup.info/api/2fa/generate",
                {},
                { headers: { Authorization: "Bearer " + user.token } }
            );
            return data; // { qrData, tempSecret }
        }catch(error){
            throw error.response.data;
        }
    }
}

// 2️⃣ Verify 2FA setup
export function verify2FASetupApi(token){
    return async(dispatch, getState)=>{
        try{
            const {user} = getState().auth;
            const {data} = await axios.post(
                "https://remote-attendance.hsagroup.info/api/2fa/verify",
                { token },
                { headers: { Authorization: "Bearer " + user.token } }
            );
            return data;
        }catch(error){
            throw error.response.data;
        }
    }
}
